// core/stores/forYouStore.ts — the For-You tab's server-picked id list.
//
// Lives outside the Home page component so postsService.createPost can keep it
// current: without this, a post you just published doesn't appear on the For
// You tab until you switch away and back (the id list is only ever populated by
// the ?feed=for-you fetch). `prependId` is a no-op while `ids` is null — the
// viewer hasn't opened the For You tab yet this session, so there's nothing to
// keep in sync.
import { create } from 'zustand';

interface ForYouState {
  ids: string[] | null;
  setIds: (ids: string[]) => void;
  prependId: (id: string) => void;
  /** Fix-round item 22 (1.21.60 adversarial review): back to the "not opened
   * this session" state. Called on sign-out (authService.signOut) so a
   * sign-in-as-a-different-account afterward can't flash the PRIOR account's
   * For You id list for a frame before its own fetch lands — the same sign-
   * out hygiene useFollowStore's setFollows({})/setRequests({}) already do. */
  clear: () => void;
}

export const useForYouStore = create<ForYouState>((set) => ({
  ids: null,
  setIds: (ids) => set({ ids }),
  prependId: (id) => set((s) => (s.ids ? { ids: [id, ...s.ids] } : s)),
  clear: () => set({ ids: null }),
}));
